import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react18-swipeable-views";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import imgApi from "dan-api/images/photos";
import NewsCard from "../CardPaper/NewsCard";
import PapperBlock from "../PapperBlock/PapperBlock";
import useStyles from "../SocialMedia/jss/socialMedia-jss";

const slideData = [
  {
    label: [
      { text: "text 1", url: "/" },
      { text: "text 2", url: "/" },
      { text: "text 3", url: "/" },
    ],
    imgPath: imgApi[49],
  },
  {
    label: [
      { text: "confrence 2", url: "/" },
      { text: "confrence 2", url: "/" },
      { text: "confrence 2", url: "/" },
    ],
    imgPath: imgApi[17],
  },
  {
    label: "confrence 3",
    imgPath: imgApi[34],
  },
  {
    label: "confrence 4",
    imgPath: imgApi[10],
  },
  {
    label: "confrence 5",
    imgPath: imgApi[40],
  },
];

function Confrence() {
  const [activeStepSwipe, setActiveStepSwipe] = useState(0);
  const theme = useTheme();
  const { classes, cx } = useStyles();

  const handleNextSwipe = () => {
    setActiveStepSwipe((swipe) => swipe + 1);
  };

  const handleBackSwipe = () => {
    setActiveStepSwipe((swipe) => swipe - 1);
  };

  const handleStepChangeSwipe = (swipe) => {
    setActiveStepSwipe(swipe);
  };

  const maxStepsSwipe = slideData.length;

  return (
    <div>
      <Paper>
        <PapperBlock
          title="Upcoming Confrence"
          icon="ion-ios-people-outline"
          whiteBg
          noMargin
          desc=""
        >
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={activeStepSwipe}
            onChangeIndex={handleStepChangeSwipe}
            enableMouseEvents
            className={classes.sliderWrap}
          >
            {/* {slideData.map((slide, index) => (
              <div className={classes.figure} key={index.toString()}>
              
                <Typography
                  gutterBottom
                  className={classes.title}
                  variant="h5"
                  component="h2"
                >
                  {slide.label}
                </Typography>
            
              </div>
            ))} */}
            {slideData.map((item, index) => (
              <div key={index} className="slide-item">
                <span>
                  {Array.isArray(item.label) ? (
                    <ul>
                      {item.label.map((listItem, idx) => (
                        <li className="py-2" key={idx}>
                          <a href={listItem.url}>{listItem.text}</a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    item.label
                  )}
                </span>
              </div>
            ))}
          </SwipeableViews>
          <MobileStepper
            variant="dots"
            steps={maxStepsSwipe}
            position="static"
            activeStep={activeStepSwipe}
            className={classes.mobileStepper}
            nextButton={
              <Button
                size="small"
                onClick={handleNextSwipe}
                disabled={activeStepSwipe === maxStepsSwipe - 1}
              >
                Next
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBackSwipe}
                disabled={activeStepSwipe === 0}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Back
              </Button>
            }
          />
        </PapperBlock>
      </Paper>

      <Divider className={classes.divider} />
    </div>
  );
}

export default Confrence;
